export const GROUPS_SET_GROUP_SUPERVISORS = 'groups/set-group-supervisors';
export const GROUPS_SET_GROUP_TRADE_LIMITS = 'groups/set-group-trade-limits';
export const GROUPS_SET_GROUPS = 'groups/set-groups';